// eslint-disable-next-line import/no-cycle
import CreateDocumentPopup from "./CreateDocumentPopup";

export default CreateDocumentPopup;



// WEBPACK FOOTER //
// ./src/components/CreateDocumentPopup/index.js